import { Action } from '@ngrx/store';
import { UserRegistration, CustomerUserType, ManagerCompany } from '@model';

export enum UserRegistrationActionTypes {
  UserRegistrationUpdateItem = '[UserRegistration] Update',
  UserRegistrationUpdateItemSuccess = '[UserRegistration] Update success',
  UserRegistrationUpdateItemFail = '[UserRegistration] Update fail',

  AutoUserRegistration = '[AutoUserRegistration] create',
  AutoUserRegistrationSuccess = '[AutoUserRegistration] create success',
  AutoUserRegistrationFail = '[AutoUserRegistration] create fail',
  
  IsCustomerUserTypeValid = '[UserRegistration] Validate Customer for UserType',
  IsCustomerUserTypeValidSuccess = '[UserRegistration] Validate Customer for UserType success',
  IsCustomerUserTypeValidFail = '[UserRegistration] Validate Customer for UserType fail',

  IsManagerCompanyOrgNumberExistingCustomer = '[ManagerCompany] Validate OrgNumber for ManagerCompany',
  IsManagerCompanyOrgNumberExistingCustomerSuccess = '[ManagerCompany] Validate OrgNumber for ManagerCompany success',
  IsManagerCompanyOrgNumberExistingCustomerFail = '[ManagerCompany] Validate OrgNumber for ManagerCompany fail',

  IsRegisteredOnSegment = '[UserRegistration] Is Manager registered for Customer',
  IsRegisteredOnSegmentSuccess = '[UserRegistration] Is Manager registered for Customer success',
  IsRegisteredOnSegmentFail = '[UserRegistration] Is Manager registered for Customer fail',

  AdditionalCustomerRegistration = '[AdditionalCustomerRegistration] Update',
  AdditionalCustomerRegistrationSuccess = '[AdditionalCustomerRegistration] Update success',
  AdditionalCustomerRegistrationFail = '[AdditionalCustomerRegistration] Update fail',

  ClearCreateAdditionalCustomerState = '[AdditionalCustomerRegistration]  Clear create state',

  IsRegisteredOnCompany = '[UserRegistration] Is Manager registered on Company',
  IsRegisteredOnCompanySuccess = '[UserRegistration] Is Manager registered on Company success',
  IsRegisteredOnCompanyFail = '[UserRegistration] Is Manager registered on Company fail',

  CreateManagerCompany = '[ManagerCompany] Create',
  CreateManagerCompanySuccess = '[ManagerCompany] Create success',
  CreateManagerCompanyFail = '[ManagerCompany] Create fail',

  CreateAdditionalManagerCompany = '[AdditionalManagerCompany] Create',
  CreateAdditionalManagerCompanySuccess = '[AdditionalManagerCompany] Create success',
  CreateAdditionalManagerCompanyFail = '[AdditionalManagerCompany] Create fail',

  ClearCreateManagerCompanyState = '[ManagerCompany] Clear create state',
  ClearUpdateUserRegistrationState = '[ManagerCompany] Clear update user reg state',

  ManagerCompanyLoad = '[ManagerCompanyLoad] Load',
  ManagerCompanyLoadSuccess = '[ManagerCompanyLoad] Load sucess',
  ManagerCompanyLoadFail = '[ManagerCompanyLoad] Load fail',

  CustomerUserTypeLoadData = '[UserRegistration] Load Customer UserType',
  CustomerUserTypeLoadDataSuccess = '[UserRegistration] Load Customer UserType success',
  CustomerUserTypeLoadDataFail = '[UserRegistration] Load Customer UserType fail',
  ClearCustomerUserTypeState = '[UserRegistration] Clear Customer UserType state',
  ClearManagerCustomerValidState = '[UserRegistration] Clear Manager Customer Validation state',

  IsCustomerMeteringPointsValid = '[UserRegistration] Validate Customer existing any MeteringPoints',
  IsCustomerMeteringPointsValidSuccess = '[UserRegistration] Validate Customer existing any MeteringPoints success',
  IsCustomerMeteringPointsValidFail = '[UserRegistration] Validate Customer existing any MeteringPoints fail',
}

export class UserRegistrationUpdate implements Action {
  readonly type = UserRegistrationActionTypes.UserRegistrationUpdateItem;
  constructor(public payload: UserRegistration) {}
}
export class UserRegistrationUpdateSuccess implements Action {
  readonly type = UserRegistrationActionTypes.UserRegistrationUpdateItemSuccess;
  constructor() {}
}
export class UserRegistrationUpdateFail implements Action {
  readonly type = UserRegistrationActionTypes.UserRegistrationUpdateItemFail;
  constructor(public payload: any) {}
}

export class AutoUserRegistration implements Action {
  readonly type = UserRegistrationActionTypes.AutoUserRegistration;
  constructor(public payload: UserRegistration) {}
}
export class AutoUserRegistrationSuccess implements Action {
  readonly type = UserRegistrationActionTypes.AutoUserRegistrationSuccess;
  constructor() {}
}
export class AutoUserRegistrationFail implements Action {
  readonly type = UserRegistrationActionTypes.AutoUserRegistrationFail;
  constructor(public payload: any) {}
}

export class IsCustomerUserTypeValid implements Action {
  readonly type = UserRegistrationActionTypes.IsCustomerUserTypeValid;
  constructor(public payload: CustomerUserType) {}
}
export class IsCustomerUserTypeValidSuccess implements Action {
  readonly type = UserRegistrationActionTypes.IsCustomerUserTypeValidSuccess;
  constructor(public payload: boolean) {}
}
export class IsCustomerUserTypeValidFail implements Action {
  readonly type = UserRegistrationActionTypes.IsCustomerUserTypeValidFail;
  constructor(public payload: any) {}
}

export class IsManagerCompanyOrgNumberExistingCustomer implements Action {
  readonly type = UserRegistrationActionTypes.IsManagerCompanyOrgNumberExistingCustomer;
  constructor(public payload: string) {}
}
export class IsManagerCompanyOrgNumberExistingCustomerSuccess implements Action {
  readonly type = UserRegistrationActionTypes.IsManagerCompanyOrgNumberExistingCustomerSuccess;
  constructor(public payload: boolean) {}
}
export class IsManagerCompanyOrgNumberExistingCustomerFail implements Action {
  readonly type = UserRegistrationActionTypes.IsManagerCompanyOrgNumberExistingCustomerFail;
  constructor(public payload: any) {}
}

export class IsRegisteredOnSegment implements Action {
  readonly type = UserRegistrationActionTypes.IsRegisteredOnSegment;
  constructor(public payload: string) {}
}
export class IsRegisteredOnSegmentSuccess implements Action {
  readonly type = UserRegistrationActionTypes.IsRegisteredOnSegmentSuccess;
  constructor(public payload: boolean) {}
}
export class IsRegisteredOnSegmentFail implements Action {
  readonly type = UserRegistrationActionTypes.IsRegisteredOnSegmentFail;
  constructor(public payload: any) {}
}

export class AdditionalCustomerRegistration implements Action {
  readonly type = UserRegistrationActionTypes.AdditionalCustomerRegistration;
  constructor(public payload: UserRegistration) {}
}
export class AdditionalCustomerRegistrationSuccess implements Action {
  readonly type = UserRegistrationActionTypes.AdditionalCustomerRegistrationSuccess;
  constructor() {}
}
export class AdditionalCustomerRegistrationFail implements Action {
  readonly type = UserRegistrationActionTypes.AdditionalCustomerRegistrationFail;
  constructor(public payload: any) {}
}

export class IsRegisteredOnCompany implements Action {
  readonly type = UserRegistrationActionTypes.IsRegisteredOnCompany;
  constructor(public payload: string) {}
}
export class IsRegisteredOnCompanySuccess implements Action {
  readonly type = UserRegistrationActionTypes.IsRegisteredOnCompanySuccess;
  constructor(public payload: boolean) {}
}
export class IsRegisteredOnCompanyFail implements Action {
  readonly type = UserRegistrationActionTypes.IsRegisteredOnCompanyFail;
  constructor(public payload: any) {}
}

export class CreateManagerCompany implements Action {
  readonly type = UserRegistrationActionTypes.CreateManagerCompany;
  constructor(public payload: ManagerCompany) {}
}
export class CreateManagerCompanySuccess implements Action {
  readonly type = UserRegistrationActionTypes.CreateManagerCompanySuccess;
  constructor(public payload: ManagerCompany) {}
}
export class CreateManagerCompanyFail implements Action {
  readonly type = UserRegistrationActionTypes.CreateManagerCompanyFail;
  constructor(public payload: any) {}
}

export class CreateAdditionalManagerCompany implements Action {
  readonly type = UserRegistrationActionTypes.CreateAdditionalManagerCompany;
  constructor(public payload: ManagerCompany) {}
}
export class CreateAdditionalManagerCompanySuccess implements Action {
  readonly type = UserRegistrationActionTypes.CreateAdditionalManagerCompanySuccess;
  constructor(public payload: ManagerCompany) {}
}
export class CreateAdditionalManagerCompanyFail implements Action {
  readonly type = UserRegistrationActionTypes.CreateAdditionalManagerCompanyFail;
  constructor(public payload: any) {}
}

export class ClearCreateManagerCompanyState implements Action {
  readonly type = UserRegistrationActionTypes.ClearCreateManagerCompanyState;
  constructor() {}
}
export class ClearUpdateUserRegistrationState implements Action {
  readonly type = UserRegistrationActionTypes.ClearUpdateUserRegistrationState;
  constructor() {}
}
export class ClearCreateAdditionalCustomerState implements Action {
  readonly type = UserRegistrationActionTypes.ClearCreateAdditionalCustomerState;
  constructor() {}
}

export class CustomerUserTypeLoad implements Action {
  readonly type = UserRegistrationActionTypes.CustomerUserTypeLoadData;
  constructor(public payload: string) {}
}
export class CustomerUserTypeLoadSuccess implements Action {
  readonly type = UserRegistrationActionTypes.CustomerUserTypeLoadDataSuccess;
  constructor(public payload: number) {}
}
export class CustomerUserTypeLoadFail implements Action {
  readonly type = UserRegistrationActionTypes.CustomerUserTypeLoadDataFail;
  constructor(public payload: any) {}
}
export class ClearCustomerUserTypeState implements Action {
  readonly type = UserRegistrationActionTypes.ClearCustomerUserTypeState;
  constructor() {}
}
export class ClearManagerCustomerValidState implements Action {
  readonly type = UserRegistrationActionTypes.ClearManagerCustomerValidState;
  constructor() {}
}

export class IsCustomerMeteringPointsValid implements Action {
  readonly type = UserRegistrationActionTypes.IsCustomerMeteringPointsValid;
  constructor(public payload: string) {}
}
export class IsCustomerMeteringPointsValidSuccess implements Action {
  readonly type = UserRegistrationActionTypes.IsCustomerMeteringPointsValidSuccess;
  constructor(public payload: boolean) {}
}
export class IsCustomerMeteringPointsValidFail implements Action {
  readonly type = UserRegistrationActionTypes.IsCustomerMeteringPointsValidFail;
  constructor(public payload: any) {}
}

export type UserRegistrationActions =
  | UserRegistrationUpdate
  | UserRegistrationUpdateSuccess
  | UserRegistrationUpdateFail
  | AutoUserRegistration 
  | AutoUserRegistrationSuccess
  | AutoUserRegistrationFail 
  | IsCustomerUserTypeValid
  | IsCustomerUserTypeValidSuccess
  | IsCustomerUserTypeValidFail
  | IsRegisteredOnSegment
  | IsRegisteredOnSegmentSuccess
  | IsRegisteredOnSegmentFail
  | AdditionalCustomerRegistration
  | AdditionalCustomerRegistrationSuccess
  | AdditionalCustomerRegistrationFail
  | IsRegisteredOnCompany
  | IsRegisteredOnCompanySuccess
  | IsRegisteredOnCompanyFail
  | CreateManagerCompany
  | CreateManagerCompanySuccess
  | CreateManagerCompanyFail
  | CreateAdditionalManagerCompany
  | CreateAdditionalManagerCompanySuccess
  | CreateAdditionalManagerCompanyFail
  | ClearCreateManagerCompanyState
  | ClearUpdateUserRegistrationState
  | ClearCreateAdditionalCustomerState
  | CustomerUserTypeLoad
  | CustomerUserTypeLoadSuccess
  | CustomerUserTypeLoadFail
  | ClearCustomerUserTypeState
  | ClearManagerCustomerValidState
  | IsManagerCompanyOrgNumberExistingCustomer
  | IsManagerCompanyOrgNumberExistingCustomerSuccess
  | IsManagerCompanyOrgNumberExistingCustomerFail
  | IsCustomerMeteringPointsValid
  | IsCustomerMeteringPointsValidSuccess 
  | IsCustomerMeteringPointsValidFail;
